import { Component, Renderer2, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { DataTableDirective } from "angular-datatables";
import { BaseServiceService } from "../../services/base-service.service";
import {
  ModalNotifyComponent,
  ModalNotifyTypes,
} from "../modal-notify/modal-notify.component";
import { Conector } from "../../models/conector.model";
import { HttpClient } from "@angular/common/http";
import { AppData } from "../../helpers/app-data";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { lastValueFrom } from "rxjs";
import { DiagramViewerComponent } from "../diagram-viewer/diagram-viewer.component";

declare var fabric: any;

@Component({
  selector: "app-conectores",
  templateUrl: "./conectores.component.html",
  styleUrl: "./conectores.component.css",
})
export class ConectoresComponent {
  @ViewChild(ModalNotifyComponent) modalNotifyComponent!: ModalNotifyComponent;
  @ViewChild(DiagramViewerComponent) diagramViewer!: DiagramViewerComponent;

  dialogComponentCreate: any;
  dialogComponentEdit: any;
  formSubmitted: boolean = false;
  botonProcesando = false;
  textoBotonProcesando = "Cargando...";
  idConector: any;
  getDataTableConectores: any = ["Conector", "GetDataTableConector"];

  @ViewChild(DataTableDirective, { static: false })
  dtElement: any;
  dtInstance: DataTables.Api | any = null;
  dtOptButtons: any = [];

  dtOptions: DataTables.Settings = {};
  response: any[] = [];
  titulo: string = "";
  internalDescription: string = "";
  dtTrigger: any;
  valorCompartido: any;
  validateDel: boolean = false;
  dialogComponentCreateConector: any;
  dialogComponentDuplicarConector: any;
  dialogComponentImportarConector: any;
  conectorForm: FormGroup | any = null;
  conectorObj: Conector;
  auxImport: boolean = false;
  conectorDuplicado: any = '';
  isEmpty: any = null;
  
  // Variables para el modal del diagrama
  modalDiagramaVisible: boolean = false;
  xmlContent: string = '';
  mostrarDiagrama: boolean = false;
  idConectorTitle?: number;
  NombreConectorTitle?: string;
  
  // Variables para el modal de configuración InOut
  modalConfiguracionInOutVisible: boolean = false;
  variablesEntrada: string[] = [''];
  variablesSalida: string[] = [''];
  botonProcesandoInOut: boolean = false;
  
  // Lista de tipos de conectores
  tipoConectoresList: any[] = [];
  
  booleanColumnRenderer = (data: any, type: any, row: any, meta: any) => {
    if (type === "display") {
      return `<input type="checkbox" disabled ${data ? "checked" : ""}>`;
    }
    return data;
  };
  
  columnas = [
    { title: "ID", data: "Id" },
    { title: "Nombre", data: "Nombre" },  
    { title: "Descripcion", data: "Descripcion" },
    { title: "Tipo conector", data: "NombreTipoConector" },
    { title: "Duplicado de", data: "NombrePadre" },
    { title: "Estado", data: "Estado" },
    { title: "Version", data: "Version" },
    { title: "Fecha Creación", data: "FechaCreacionConector" },
    { title: "Usuario Creación", data: "UsuarioCreacion" },
    { title: "Fecha Actualización", data: "FechaActualizacionConector" },
    { title: "Usuario Actualización", data: "UsuarioActualizacion" },
    {
      title: "Todos Usuarios",
      data: "TodosUsuarios",
      render: this.booleanColumnRenderer,
      orderable: false,
    },
    {
      title: "Activo",
      data: "Activo",
      render: this.booleanColumnRenderer,
      orderable: false,
    },
  ];

  constructor(
    private baseService: BaseServiceService,
    private router: Router,
    private renderer: Renderer2,
    private http: HttpClient,
    private _formBuilder: FormBuilder
  ) {
    this.conectorObj = new Conector();
    this.formInit();
  }

  clearFormConectorCreado() {
    this.conectorObj = new Conector();
    this.conectorForm.reset();
    this.idConector = null;
    this.baseService.clearForm();
  }

  async cargarTipoConectores() {
    try {
      const response = await lastValueFrom(
        this.http.post<any>(`${AppData.API_URL}TipoConector/ListaTipoConectoresResumen`, {})
      );
      if (response.Ok) {
        this.tipoConectoresList = response.Data;
      } else {
        this.tipoConectoresList = [];
      }
    } catch (error) {
      console.error("Error al cargar tipos de conectores:", error);
      this.tipoConectoresList = [];
    }
  }

  clearFormConector() {
    this.baseService.triggerShowModal(
      "Cancelar creacion del conector",
      "¿Seguro que desea cancelar la creacion del conector?",
      ModalNotifyTypes.Warning,
      true
    );

    this.modalNotifyComponent.actionConfirmed.subscribe(
      (confirmed: boolean) => {
        if (confirmed) {
          this.dialogComponentCreateConector.close();
          this.clearFormConectorCreado();
        } else {
        }
      }
    );
  }

  async abrirModalCrear() {
    this.clearFormConectorCreado();
    await this.cargarTipoConectores();
    $("#estadoConector").prop("disabled", false);
    $("#dialogCreateEdit").html("Crear Conector");
    $("#btnCreateEdit > span").html("Crear");
    this.conectorForm.controls["Activo"].setValue(true);

    const dialog = document.querySelector(".create-conectores");
    this.dialogComponentCreateConector = new fabric["Dialog"](dialog);
    this.dialogComponentCreateConector.open();
  }

  abrirDiagramador() {
    this.router.navigate(["home/design-process"]);
  }

  abrirEditorAcceso() {
    this.router.navigate(["home/acceso"]);
  }

  abrirEditorDiagramador() {
    this.router.navigate(["home/design-process"]);
  }

  async ngOnInit(): Promise<void> {
    this.dtOptButtons.push(
      {
        "button-id": "btnEdit",
        "button-icon": "ms-Icon--EditNote",
        "button-tooltip": "Editar Datos",
      },
      {
        "button-id": "btnCopyConector",
        "button-icon": "ms-Icon--Copy",
        "button-tooltip": "Duplicar Conector",
      },
      {
        "button-id": "btnImport",
        "button-icon": "ms-Icon--Upload",
        "button-tooltip": "Importar",
        'conditional-data': [{ key: 'isempty', value: 'IsEmpty' }]
      },
      {
        "button-id": "btnExport",
        "button-icon": "ms-Icon--Download",
        "button-tooltip": "Exportar",
      },
      {
        "button-id": "btnVerDiagramaConector",
        "button-icon": "ms-Icon--RedEye",
        "button-tooltip": "Ver Diagrama",
        'conditional-data': [
          { key: 'field', value: 'Nombre' }
        ]
      },
      {
        "button-id": "btnConfiguracionInOut",
        "button-icon": "ms-Icon--Settings",
        "button-tooltip": "Configurar Variables In/Out",
      },
      {
        "conditional-column": "TodosUsuarios",
        "button-id": "btnAccess",
        "button-icon": "ms-Icon--UserFollowed",
        "conditional-comparison": "not",
        "button-tooltip": "Asignar Permisos",
      },
      {
        "conditional-column": "Estado",
        "conditional-datatype": "string",
        "conditional-value": "Produccion",
        "button-id": "btnEditConector",
        "button-icon": "ms-Icon--WindowEdit",
        "conditional-comparison": "not-equals",
        "button-tooltip": "Editar Conector",
      }
    );

    var CheckBoxElements = document.querySelectorAll(".ms-CheckBox");
    for (var i = 0; i < CheckBoxElements.length; i++) {
      new fabric["CheckBox"](CheckBoxElements[i]);
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.attachClickEvents();
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.dtTrigger) {
      this.dtTrigger.unsubscribe();
    }
  }

  formInit() {
    this.conectorForm = this._formBuilder.group({
      Nombre: new FormControl("", [
        Validators.required,
        Validators.maxLength(200),
      ]),
      Descripcion: new FormControl("", [
        Validators.required,
        Validators.maxLength(700),
      ]),
      Estado: new FormControl("", [Validators.required]),
      Version: new FormControl(null, [Validators.required]),
      IdTipoConector: new FormControl("", [Validators.required]),
      TodosUsuarios: new FormControl(false),
      Activo: new FormControl(false),
    });
  }

  attachClickEvents(): void {
    const editButtons = document.querySelectorAll("#btnEdit");
    const deleteButtons = document.querySelectorAll("#btnDelete");
    const editDiagramButtons = document.querySelectorAll("#btnEditConector");
    const editAccessButton = document.querySelectorAll("#btnAccess");
    const copyConectorButton = document.querySelectorAll("#btnCopyConector");

    editButtons.forEach((button) => {
      this.renderer.listen(button, "click", (event) => {
        const id = button.getAttribute("data-id");
        this.idConector = id;
        this.abrirModalEditar();
      });
    });

    deleteButtons.forEach((button) => {
      this.renderer.listen(button, "click", (event) => {
        const userId = button.getAttribute("data-id");
        this.delete(Number(userId));
      });
    });

    editDiagramButtons.forEach((button) => {
      this.renderer.listen(button, "click", (event) => {
        const userId = button.getAttribute("data-id");
        this.baseService.exportIDProcess(userId!);
        this.abrirEditorDiagramador();
      });
    });

    editAccessButton.forEach((button) => {
      this.renderer.listen(button, "click", (event) => {
        const userId = button.getAttribute("data-id");
        this.baseService.exportIDProcess(userId!);
        this.baseService.exportIsOptionMenu(false);

        this.abrirEditorAcceso();
      });
    });
    
    copyConectorButton.forEach((button) => {
      this.renderer.listen(button, "click", (event) => {
        const conectorId = button.getAttribute("data-id");
        this.idConector = conectorId;
        this.abrirModalDuplicar();
      });
    });
  }

  gridLoaded(event: any) {
    this.dtInstance = event["table"];
  }

  customClick(event: any) {
    try {
      this.idConector = event["data-id"];

      switch (event["button-id"]) {
        case "btnEdit":
          this.abrirModalEditar();
          break;
        case "btnDelete":
          this.delete(Number(this.idConector));
          break;
        case "btnEditConector":
          AppData.DIAGRAM_URL =
            AppData.DIAGRAM_DATA +
            "?Tipo=conector&Id=" +
            this.idConector +
            "&Token=" +
            sessionStorage.getItem(AppData.localStorageToken);
          console.log(AppData.DIAGRAM_URL);
          this.abrirEditorDiagramador();
          break;
        case "btnAccess":
          this.baseService.exportIDProcess(this.idConector);
          this.baseService.exportIsOptionMenu(false);
          this.abrirEditorAcceso();
          break;
        case "btnCopyConector":
          this.abrirModalDuplicar();
          break;
        case "btnImport":
          this.auxImport = true;
          this.isEmpty = event['data-isempty'];
          this.abrirModalImportar();
          break;
        case "btnExport":
          this.auxImport = false;
          this.exportarConector();
          break;
        case "btnVerDiagramaConector":
          this.NombreConectorTitle = event['data-field'];
          this.idConectorTitle = this.idConector;
          this.cargarDiagramaConector();
          break;
        case "btnConfiguracionInOut":
          this.abrirModalConfiguracionInOut();
          break;
      }
    } catch (error) {
      console.error("Error al retornar evento datatable", error);
    }
  }

  async edit(userId: number) {
    try {
      await this.baseService.setIdSeleccionado(userId);
      this.baseService.abrirModalEditar();
    } catch (error) {
      console.error("Error al establecer el ID:", error);
    }
  }

  async delete(userId: number) {
    try {
      this.baseService.triggerShowModal(
        "Eliminar Conector",
        "¿Seguro que desea eliminar el Conector?",
        ModalNotifyTypes.Warning,
        true
      );

      this.modalNotifyComponent.actionConfirmed.subscribe(
        (confirmed: boolean) => {
          if (confirmed) {
            this.baseService
              .delete("Conector/BorrarConector", userId)
              .then(() => {
                this.reloadDataTable();
                this.baseService.triggerShowModal(
                  "Conector Eliminado",
                  "Conector Eliminado Correctamente",
                  ModalNotifyTypes.Success,
                  false
                );
              });
          } else {
          }
        }
      );
    } catch (error: any) {
      this.baseService.triggerShowModal(
        "Error al enviar el formulario:",
        error,
        ModalNotifyTypes.Danger,
        false
      );
    }
  }

  reloadDataTable(): void {
    this.dtInstance.ajax.reload(undefined, false);
  }

  dialogComponent: any = null;

  async crearEditarConector() {
    this.botonProcesando = true;
    this.conectorObj.Nombre = this.conectorForm.get("Nombre")!.value;
    this.conectorObj.Descripcion = this.conectorForm.get("Descripcion")!.value;
    this.conectorObj.Version = this.conectorForm.get("Version")!.value;
    this.conectorObj.IdTipoConector = this.conectorForm.get("IdTipoConector")!.value;
    this.conectorObj.TodosUsuarios = this.conectorForm.get("TodosUsuarios")!.value;
    this.conectorObj.Activo = this.conectorForm.get("Activo")!.value;
    this.conectorObj.Configuracion = "";
    this.conectorObj.Estado = parseInt(this.conectorObj.Estado as any);

    try {
      if (this.idConector) {
        const response = await this.baseService.update(
          "Conector/ActualizarConector",
          this.idConector,
          this.conectorObj
        );

        if (!response.Ok) {
          this.dialogComponentCreate.close();

          let mensajeError = "<ul>";
          response.ValidationErrors.forEach((error: any) => {
            mensajeError += `<li>${error}</li>`;
          });
          mensajeError += "</ul>";

          this.baseService.triggerShowModal(
            "Error al editar Conector",
            mensajeError,
            ModalNotifyTypes.Danger,
            false
          );
          this.botonProcesando = false;
        } else {
          this.dialogComponentCreateConector.close();
          this.baseService.triggerShowModal(
            "Conector Editado",
            "Se ha almacenado el registro correctamente ",
            ModalNotifyTypes.Success,
            false
          );
          this.botonProcesando = false;
          this.reloadDataTable();
        }
      } else {
        const response = await this.baseService.create(
          "Conector/CrearConector",
          this.conectorObj
        );

        if (!response.Ok) {
          this.dialogComponentCreateConector.close();

          let mensajeError = "<ul>";
          response.ValidationErrors.forEach((error: any) => {
            mensajeError += `<li>${error}</li>`;
          });
          mensajeError += "</ul>";

          this.baseService.triggerShowModal(
            "Error al crear Conector",
            mensajeError,
            ModalNotifyTypes.Danger,
            false
          );
          this.botonProcesando = false;
        } else {
          this.dialogComponentCreateConector.close();

          var example = document.querySelector(".success");
          var dialog = example!.querySelector(".modal-succes");

          this.dialogComponent = new fabric["Dialog"](dialog);
          this.dialogComponent.open();

          this.botonProcesando = false;
          this.reloadDataTable();
        }
      }
    } catch (error: any) {
      this.dialogComponentCreateConector.close();

      let mensajeError = error.error.Error;

      this.baseService.triggerShowModal(
        "Error",
        mensajeError,
        ModalNotifyTypes.Danger,
        false
      );
      this.botonProcesando = false;
    }
  }

  cerrarModal() {
    this.dialogComponent.close();
  }

  async abrirModalEditar() {
    try {
      if (this.idConector !== null) {
        await this.cargarTipoConectores();
        const responseById = await this.baseService.getById(
          "Conector/GetConector",
          this.idConector
        );
        if (responseById.Data) {
          const Data = responseById.Data;
          this.conectorForm.controls["Nombre"].setValue(Data.Nombre);
          this.conectorForm.controls["Descripcion"].setValue(Data.Descripcion);
          this.conectorForm.controls["Estado"].setValue(Data.Estado);
          this.conectorForm.controls["Version"].setValue(Data.Version);
          this.conectorForm.controls["IdTipoConector"].setValue(Data.IdTipoConector);
          this.conectorForm.controls["TodosUsuarios"].setValue(Data.TodosUsuarios);
          this.conectorForm.controls["Activo"].setValue(Data.Activo);
          this.conectorObj.Estado = Data.Estado;

          $("#dialogCreateEdit").html("Editar Conector");
          $("#btnCreateEdit > span").html("Actualizar");

          if (Data.Estado == 3) {
            $("#estadoConector").prop("disabled", true);
          } else {
            $("#estadoConector").prop("disabled", false);
          }
          const dialog = document.querySelector(".create-conectores");
          this.dialogComponentCreateConector = new fabric["Dialog"](dialog);
          this.dialogComponentCreateConector.open();
        }
      }
    } catch (error: any) {
      this.baseService.triggerShowModal(
        "Error",
        error.Error,
        ModalNotifyTypes.Danger,
        false
      );
    }
  }

  abrirModalDuplicar() {
    const dialog = document.querySelector(".modal-duplicar");
    this.dialogComponentDuplicarConector = new fabric["Dialog"](dialog);
    this.dialogComponentDuplicarConector.open();
  }

  selectedFile: any;
  abrirModalImportar() {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".bpmn";
  
    input.onchange = async () => {
      const file = input.files ? input.files[0] : null;
  
      if (file) {
        var ext = file.name.split(".").pop();
        if (ext != "bpmn") {
          let mensajeError =
            "Extensión " +
            ext +
            " no valida, por favor cargue un archivo con extensión .bpmn";
          this.baseService.triggerShowModal(
            "Error al importar Conector",
            mensajeError,
            ModalNotifyTypes.Danger,
            false
          );
        } else {
          this.selectedFile = file;

          const dialog = document.querySelector(".modal-Importar");
          this.dialogComponentImportarConector = new fabric["Dialog"](dialog);
          this.dialogComponentImportarConector.open();
        }
      }
    };
  
    input.click();
  }

  async duplicarConector() {
    this.botonProcesando = true;

    try {
      const response = await lastValueFrom(
        this.http.post<any>(
          AppData.API_URL + "Conector/ClonarConector?Id=" + this.idConector,
          null
        )
      );

      if (!response.Ok) {
        this.dialogComponentDuplicarConector.close();

        let mensajeError = "<ul>";
        response.ValidationErrors.forEach((error: any) => {
          mensajeError += `<li>${error}</li>`;
        });
        mensajeError += "</ul>";

        this.baseService.triggerShowModal(
          "Error al duplicar Conector",
          mensajeError,
          ModalNotifyTypes.Danger,
          false
        );
        this.botonProcesando = false;
      } else {
        this.dialogComponentDuplicarConector.close();

        this.conectorDuplicado = response.Data.nombre;

        var example = document.querySelector(".duplicado");
        var dialog = example!.querySelector(".duplicado-succes");

        this.dialogComponent = new fabric["Dialog"](dialog);
        this.dialogComponent.open();

        this.botonProcesando = false;
        this.reloadDataTable();
      }
    } catch (error: any) {
      this.dialogComponentDuplicarConector.close();

      let mensajeError = error.error.Error;

      this.baseService.triggerShowModal(
        "Error",
        mensajeError,
        ModalNotifyTypes.Danger,
        false
      );
      this.botonProcesando = false;
    }
  }

  async importarConector() {
    this.botonProcesando = true;

    if (this.selectedFile && this.idConector !== null) {
      const fileContent = await this.selectedFile.text();

      try {
        const response = await lastValueFrom(
          this.http.post<any>(
            `${AppData.API_URL}Conector/ActualizarConectorConfiguracion?Id=${Number(
              this.idConector
            )}`,
            {
              Configuracion: fileContent,
              Import: true,
            },
            {
              headers: { "Content-Type": "application/json" },
            }
          )
        );

        if (!response.Ok) {
          let mensajeError = "<ul>";
          response.ValidationErrors.forEach((error: any) => {
            mensajeError += `<li>${error}</li>`;
          });
          mensajeError += "</ul>";

          this.baseService.triggerShowModal(
            "Error al importar Conector",
            mensajeError,
            ModalNotifyTypes.Danger,
            false
          );
          this.botonProcesando = false;
        } else {
          var example = document.querySelector(".importado-s");
          var dialog = example!.querySelector(".importado-succes");

          this.dialogComponent = new fabric["Dialog"](dialog);
          this.dialogComponent.open();

          this.botonProcesando = false;
          this.reloadDataTable();
        }
      } catch (error: any) {
        let mensajeError = error.error.Error;

        this.baseService.triggerShowModal(
          "Error",
          mensajeError,
          ModalNotifyTypes.Danger,
          false
        );
        this.botonProcesando = false;
      }
    } else {
      this.baseService.triggerShowModal(
        "Error",
        "No se seleccionó ningún archivo o el conector no es válido.",
        ModalNotifyTypes.Danger,
        false
      );
      this.botonProcesando = false;
    }

    this.dialogComponentImportarConector.close();
  }

  async exportarConector() {
    this.botonProcesando = true;

    if (this.idConector === null) {
      this.baseService.triggerShowModal(
        "Error",
        "El conector no es válido.",
        ModalNotifyTypes.Danger,
        false
      );
      this.botonProcesando = false;
      return;
    }

    const responseById = await this.baseService.getById(
      "Conector/GetConectorConfiguracion",
      this.idConector
    );

    if (!responseById.Ok) {
      let mensajeError = "<ul>";
      responseById.ValidationErrors.forEach((error: any) => {
        mensajeError += `<li>${error}</li>`;
      });
      mensajeError += "</ul>";

      this.baseService.triggerShowModal(
        "Error al exportar Conector",
        mensajeError,
        ModalNotifyTypes.Danger,
        false
      );
      this.botonProcesando = false;
      return;
    }

    const xmlData = responseById.Data.Configuracion.trim();

    const blob = new Blob([xmlData], { type: 'text/xml;charset=utf-8' });
    const link = document.createElement('a');
    const url = window.URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `${responseById.Data.Nombre || 'conector'}.bpmn`);
    link.style.display = 'none';
    document.body.appendChild(link);

    setTimeout(() => {
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 0);

    this.baseService.triggerShowModal(
      "Exportar Conector",
      "Conector exportado correctamente",
      ModalNotifyTypes.Success,
      false
    );
    this.botonProcesando = false;
  }
  
  async cargarDiagramaConector() {
    this.mostrarDiagrama = false;
    this.modalDiagramaVisible = true;

    try {
      const headers = {
        'X-APIKey': AppData.API_KEY,
        'Authorization': 'Bearer ' + sessionStorage.getItem(AppData.localStorageToken)
      };

      const response = await lastValueFrom(
        this.http.get<any>(
          `${AppData.API_URL}Conector/GetConectorConfiguracion?Id=${this.idConector}`,
          { headers }
        )
      );

      if (response && response.Data && response.Data.Configuracion) {
        this.xmlContent = response.Data.Configuracion;
        this.mostrarDiagrama = true;
      } else {
        this.baseService.triggerShowModal(
          "Error",
          "No se pudo cargar el diagrama del conector",
          ModalNotifyTypes.Danger,
          false
        );
        this.cerrarModalDiagrama();
      }
    } catch (error: any) {
      let mensajeError = error.error ? error.error.Error : "Error al cargar el diagrama";

      this.baseService.triggerShowModal(
        "Error",
        mensajeError,
        ModalNotifyTypes.Danger,
        false
      );
      this.cerrarModalDiagrama();
    }
  }

  cerrarModalDiagrama() {
    this.modalDiagramaVisible = false;
    this.mostrarDiagrama = false;
  }

  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, "");
  }
  
  async downloadConectorPDF() {
    // Implementar funcionalidad de descarga PDF si es necesaria
    console.log("Descargar conector como PDF");
  }

  // Métodos para configuración de Variables InOut
  async abrirModalConfiguracionInOut() {
    this.modalConfiguracionInOutVisible = true;
    this.botonProcesandoInOut = false;
    
    // Cargar configuración existente si hay
    try {
      const responseById = await this.baseService.getById(
        "Conector/GetConector",
        this.idConector
      );
      
      if (responseById.Data && responseById.Data.ConfiguracionInOut) {
        try {
          const config = JSON.parse(responseById.Data.ConfiguracionInOut);
          this.variablesEntrada = config.entrada && config.entrada.length > 0 ? config.entrada : [''];
          this.variablesSalida = config.salida && config.salida.length > 0 ? config.salida : [''];
        } catch (e) {
          // Si hay error al parsear, inicializar vacío
          this.variablesEntrada = [''];
          this.variablesSalida = [''];
        }
      } else {
        this.variablesEntrada = [''];
        this.variablesSalida = [''];
      }
    } catch (error) {
      this.variablesEntrada = [''];
      this.variablesSalida = [''];
    }
  }

  agregarVariableEntrada() {
    this.variablesEntrada.push('');
  }

  eliminarVariableEntrada(index: number) {
    if (this.variablesEntrada.length > 1) {
      this.variablesEntrada.splice(index, 1);
    }
  }

  agregarVariableSalida() {
    this.variablesSalida.push('');
  }

  eliminarVariableSalida(index: number) {
    if (this.variablesSalida.length > 1) {
      this.variablesSalida.splice(index, 1);
    }
  }

  limpiarConfiguracionInOut() {
    this.variablesEntrada = [''];
    this.variablesSalida = [''];
  }

  cerrarModalConfiguracionInOut() {
    this.modalConfiguracionInOutVisible = false;
    this.limpiarConfiguracionInOut();
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }

  validarNombreVariable(event: Event, index: number, tipo: 'entrada' | 'salida'): void {
    const input = event.target as HTMLInputElement;
    // Solo permite letras (sin ñ), números y guion bajo
    const valorLimpio = input.value.replace(/[^a-zA-Z0-9_]/g, '');
    
    if (tipo === 'entrada') {
      this.variablesEntrada[index] = valorLimpio;
    } else {
      this.variablesSalida[index] = valorLimpio;
    }
    
    // Actualizar el valor del input
    input.value = valorLimpio;
  }

  isConfiguracionInOutValida(): boolean {
    const entradasValidas = this.variablesEntrada.filter(v => v.trim() !== '').length > 0;
    const salidasValidas = this.variablesSalida.filter(v => v.trim() !== '').length > 0;
    return entradasValidas && salidasValidas;
  }

  async guardarConfiguracionInOut() {
    this.botonProcesandoInOut = true;

    try {
      // Filtrar variables vacías
      const entradasFiltradas = this.variablesEntrada.filter(v => v.trim() !== '');
      const salidasFiltradas = this.variablesSalida.filter(v => v.trim() !== '');

      // Validar que haya al menos una variable de entrada y una de salida
      if (entradasFiltradas.length === 0) {
        this.baseService.triggerShowModal(
          "Validación",
          "Debe configurar al menos una variable de entrada",
          ModalNotifyTypes.Warning,
          false
        );
        this.botonProcesandoInOut = false;
        return;
      }

      if (salidasFiltradas.length === 0) {
        this.baseService.triggerShowModal(
          "Validación",
          "Debe configurar al menos una variable de salida",
          ModalNotifyTypes.Warning,
          false
        );
        this.botonProcesandoInOut = false;
        return;
      }

      // Crear el JSON de configuración
      const configuracion = {
        entrada: entradasFiltradas,
        salida: salidasFiltradas
      };

      const response = await lastValueFrom(
        this.http.post<any>(
          `${AppData.API_URL}Conector/ActualizarConectorConfiguracionInOut?Id=${Number(this.idConector)}`,
          {
            ConfiguracionInOut: JSON.stringify(configuracion)
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
      );

      if (!response.Ok) {
        let mensajeError = "<ul>";
        response.ValidationErrors.forEach((error: any) => {
          mensajeError += `<li>${error}</li>`;
        });
        mensajeError += "</ul>";

        this.baseService.triggerShowModal(
          "Error al guardar configuración",
          mensajeError,
          ModalNotifyTypes.Danger,
          false
        );
        this.botonProcesandoInOut = false;
      } else {
        this.baseService.triggerShowModal(
          "Configuración Guardada",
          "La configuración de variables In/Out se ha guardado correctamente",
          ModalNotifyTypes.Success,
          false
        );
        this.botonProcesandoInOut = false;
        this.cerrarModalConfiguracionInOut();
        this.reloadDataTable();
      }
    } catch (error: any) {
      let mensajeError = error.error ? error.error.Error : "Error al guardar configuración";

      this.baseService.triggerShowModal(
        "Error",
        mensajeError,
        ModalNotifyTypes.Danger,
        false
      );
      this.botonProcesandoInOut = false;
    }
  }
}
